const url = "/api/v5/companies";

// Actions

export const GET_COMPANY = "GET_COMPANY";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAILURE = "GET_COMPANY_FAILURE";

// Networking

export const getCompany = (id) => {
  return {
    types: [
      GET_COMPANY,
      GET_COMPANY_SUCCESS,
      GET_COMPANY_FAILURE,
    ],
    payload: {
      request: {
        url: `${url}/${id}`,
      },
    },
  };
};